// Module
var code = `<ul ng-if="\$ctrl.view && \$ctrl.field" class="tree"> <recursive-directive data="\$ctrl.view" field="\$ctrl.field"> </recursive-directive> <div ng-if="\$ctrl.truncated" class="mTop15 mBottom15"> <button type="button" class="btn btn-secondary btn-sm center-block" ng-click="\$ctrl.onShowMore()"> Show More Fields </button> </div> </ul> `;
// Exports
module.exports = code;